module.exports = __webpack_public_path__ + "img/Logo_EmPower-2020.cb72b2de.png";